module.exports = __webpack_public_path__ + "static/media/current-debt-banner.2ebac3b9.png";